import React, { useEffect } from 'react'
import { disabledBtnSeconds } from '../../../Constants'
import { Button } from 'antd'

function PersistentCooldownButton ({
  text,
  cooldownSeconds = disabledBtnSeconds,
  waitText = 'Можно повторить через {seconds}с',
  storageKey,
  children,
  onClick,
  ...buttonProps
}) {
  const [secondsLeft, setSecondsLeft] = React.useState(0)
  const [isDisabled, setIsDisabled] = React.useState(false)
  const intervalRef = React.useRef(null)
  const expireTimeRef = React.useRef(0)

  const startCountdownInterval = React.useCallback((expireTime) => {
    if (intervalRef.current) return

    expireTimeRef.current = expireTime

    intervalRef.current = setInterval(() => {
      const now = Date.now()
      const remaining = Math.ceil((expireTime - now) / 1000)

      if (remaining > 0) {
        setSecondsLeft(remaining)
      } else {
        stopCountdown()
      }
    }, 1000)
  }, [])

  const stopCountdown = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
    setSecondsLeft(0)
    setIsDisabled(false)
  }

  useEffect(() => {
    const saved = localStorage.getItem(storageKey)
    if (saved) {
      const expireTime = parseInt(saved)
      const now = Date.now()

      if (now < expireTime) {
        setSecondsLeft(Math.ceil((expireTime - now) / 1000))
        setIsDisabled(true)
        startCountdownInterval(expireTime)
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [storageKey, startCountdownInterval])

  const handleClick = () => {
    if (isDisabled || secondsLeft > 0) return

    const expireTime = Date.now() + cooldownSeconds * 1000
    localStorage.setItem(storageKey, expireTime.toString())

    setSecondsLeft(cooldownSeconds)
    setIsDisabled(true)
    startCountdownInterval(expireTime)

    onClick()
  }

  const displayText = secondsLeft > 0
    ? waitText.replace('{seconds}', secondsLeft.toString())
    : text

  return (
    <Button
      onClick={handleClick}
      disabled={isDisabled || secondsLeft > 0}
      style={{ width: '100%' }}
      {...buttonProps}
    >
      {displayText}
    </Button>
  )
}

export default PersistentCooldownButton
